module.exports = __webpack_public_path__ + "static/daeun-34731b24abbb6d8ff85aff6867667b9d.png";